/* MCF colour configurator engine */
(function () {
  'use strict';
  var CAT = window.MCF_CATALOG || {};
  var CFG = window.MCF_CONFIG || {};
  var fmt = function (n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); };
  var byId = function (id) { return document.getElementById(id); };

  // ============================================================================
  // CATALOGUE MODEL (single source of truth — mirrors /pages/colours)
  // ----------------------------------------------------------------------------
  // A "colour" is one row of the 48-colour catalogue:
  //   { name(beach), code(toner), shade: 'light'|'mid'|'deep', hex, family,
  //     tone, temp, toner }
  // The product was previously split across two axes (16 toner cards × a separate
  // depth selector), so the displayed name (depth-derived) never equalled the
  // tapped card (toner-only) — the "Ibiza shows Santorini" bug. We now unify on
  // the catalogue: every card IS a complete colour, so tap == selection == name.
  //
  // Tones map to the engine's dosage depths so pricing/preview shading still work:
  //   light → light (v5) · mid → medium (v15) · deep → deep (v40)
  // ============================================================================
  var TONES = ['light', 'mid', 'deep'];
  var TONE_LABEL = { light: 'Light', mid: 'Mid', deep: 'Deep' };
  var TONE_TO_DEPTHKEY = { light: 'light', mid: 'medium', deep: 'deep' };

  function depthForTone(tone) {
    var key = TONE_TO_DEPTHKEY[tone] || 'medium';
    return CFG.depths.filter(function (d) { return d.key === key; })[0] || CFG.depths[3];
  }

  // Load the catalogue printed by snippets/mcf-colours-data.liquid. Fall back to
  // synthesising it from CFG.beach + CFG.toners if the JSON tag is ever absent,
  // so the picker still renders rather than dying.
  function loadCatalogue() {
    var el = document.getElementById('mcf-colours-json');
    if (el) {
      try {
        var arr = JSON.parse(el.textContent);
        if (arr && arr.length) return arr;
      } catch (e) { /* fall through to synth */ }
    }
    var BEACH = CFG.beach || {}, out = [];
    (CFG.toners || []).forEach(function (t) {
      var m = BEACH[t.code] || {};
      TONES.forEach(function (tone) {
        out.push({ name: m[tone] || t.name, code: t.code, shade: tone, hex: t.hex, family: t.family, tone: tone, toner: t.name });
      });
    });
    return out;
  }
  var COLOURS = loadCatalogue();

  // toner sku + display name come from CFG.toners (the catalogue carries neither).
  var TONER_BY_CODE = {};
  (CFG.toners || []).forEach(function (t) { TONER_BY_CODE[t.code] = t; });
  function tonerOf(colour) { return (colour && TONER_BY_CODE[colour.code]) || {}; }

  function findColour(code, shade) {
    for (var i = 0; i < COLOURS.length; i++) {
      if (COLOURS[i].code === code && COLOURS[i].shade === shade) return COLOURS[i];
    }
    return null;
  }
  // The mid-tone sibling of any colour (same toner code) — used when switching
  // family so we land on a sensible default colour rather than nothing.
  function siblingAtTone(colour, tone) {
    return findColour(colour.code, tone) || colour;
  }

  // Display name is ALWAYS the catalogue beach name of the selected colour.
  function beachName(colour) { return (colour && colour.name) || ''; }

  // ============================================================================
  // PROJECT AREAS (ported from the Renovation Experience)
  // ----------------------------------------------------------------------------
  // The customer picks SPACES, not systems. Each area carries the surfaces it
  // usually needs (the calculator's suggested rows) and a wet/outdoor context.
  // Area context + surface type resolve to a system deterministically — the old
  // system picker is gone. 'pool' only appears when the product itself is the
  // pool kit (default_system = poolshield); the pool sits outside the funnel.
  // ============================================================================
  var AREA_IMG = function (k) { return (window.MCF_IMG && MCF_IMG.areas && MCF_IMG.areas[k]) || ''; };
  var AREAS = [
    { key: 'bathroom', tab: 'res', label: 'Bathroom', ctx: { wet: true, outdoor: false }, surfaces: ['wall', 'floor', 'ceiling'] },
    { key: 'kitchen', tab: 'res', label: 'Kitchen', ctx: { wet: false, outdoor: false }, surfaces: ['wall', 'benchtop', 'ceiling'] },
    { key: 'living', tab: 'res', label: 'Living Area', ctx: { wet: false, outdoor: false }, surfaces: ['wall', 'floor', 'ceiling'] },
    { key: 'bedroom', tab: 'res', label: 'Bedroom', ctx: { wet: false, outdoor: false }, surfaces: ['wall', 'floor', 'ceiling'] },
    { key: 'floors', tab: 'res', label: 'Floors', ctx: { wet: false, outdoor: false }, surfaces: ['floor'] },
    { key: 'walls', tab: 'res', label: 'Walls & Ceilings', ctx: { wet: false, outdoor: false }, surfaces: ['wall', 'ceiling'] },
    { key: 'joinery', tab: 'res', label: 'Joinery & Cabinetry', ctx: { wet: false, outdoor: false }, surfaces: ['benchtop'] },
    { key: 'outdoor', tab: 'res', label: 'Outdoor / Facade', ctx: { wet: true, outdoor: true }, surfaces: ['wall', 'floor'] },
    { key: 'office', tab: 'com', label: 'Entire Office', ctx: { wet: false, outdoor: false }, surfaces: ['wall', 'floor', 'ceiling'] },
    { key: 'retail', tab: 'com', label: 'Retail & Shopfronts', ctx: { wet: false, outdoor: false }, surfaces: ['wall', 'floor', 'ceiling'] },
    { key: 'lobby', tab: 'com', label: 'Hotel & Building Lobbies', ctx: { wet: false, outdoor: false }, surfaces: ['wall', 'floor', 'ceiling'] },
    { key: 'cafe', tab: 'com', label: 'Cafés & Restaurants', ctx: { wet: false, outdoor: false }, surfaces: ['wall', 'floor', 'ceiling'] },
    { key: 'pool', tab: 'res', label: 'Pool & Water Features', ctx: { wet: true, outdoor: true }, poolOnly: true, surfaces: ['wall', 'floor'] }
  ];
  var SURFACE_LABEL = { wall: 'Wall', floor: 'Floor', ceiling: 'Ceiling', benchtop: 'Benchtop' };
  function areaByKey(k) { return AREAS.filter(function (a) { return a.key === k; })[0]; }
  function sysByKey(k) { return CFG.systems.filter(function (s) { return s.key === k; })[0]; }
  // Deterministic area+surface → system resolution (the 2-axis model).
  function systemForSurface(areaDef, surfaceType) {
    if (areaDef.key === 'pool') return 'poolshield';
    if (areaDef.ctx.outdoor) return 'hydrotuff';
    if (areaDef.ctx.wet) return 'hydroshield';
    if (surfaceType === 'benchtop') return 'craftcoat';
    if (surfaceType === 'floor') return 'floormaster';
    return 'wallmaster'; // wall + ceiling indoors
  }
  function rowM2(r) {
    if (r.mode === 'm2') return parseFloat(r.m2) || 0;
    return (parseFloat(r.a) || 0) * (parseFloat(r.b) || 0);
  }

  // ---- state ----
  // Default colour: Tarifa (MCT-050 mid) to match the stage placeholder.
  var initColour = findColour('MCT-050', 'mid') || COLOURS[0];
  // Kit mode: 'diy' (materials + application tools) | 'trade' (materials only).
  var initKit = ((CFG.tools && CFG.tools.default_kit) === 'diy') ? 'diy' : 'trade';
  var state = {
    colour: initColour,
    tone: initColour.shade,           // 'light' | 'mid' | 'deep'
    depth: depthForTone(initColour.shade),
    family: 'all',
    tab: 'res',                       // residential | commercial area tab
    areas: [],                        // selected area keys (multi)
    rows: {},                         // areaKey -> calculator surface rows
    kit: initKit                      // 'diy' | 'trade'
  };
  // Seed from the product's own system tag so the page opens priced (10 m² on
  // the area that matches this kit), exactly like the old area=10 default.
  var SYS_TO_AREA = { wallmaster: 'walls', floormaster: 'floors', hydroshield: 'bathroom', hydrotuff: 'outdoor', craftcoat: 'joinery', poolshield: 'pool' };
  (function seedDefault() {
    var k = SYS_TO_AREA[CFG.default_system || ''] || 'walls';
    var def = areaByKey(k); if (!def) return;
    state.areas = [k];
    state.rows[k] = def.surfaces.map(function (t, i) {
      return { t: t, mode: i === 0 ? 'm2' : 'dims', a: '', b: '', m2: i === 0 ? '10' : '' };
    });
  })();

  // ---- helpers ----
  function variants(handle) { return (CAT[handle] && CAT[handle].variants) || []; }
  function variantBySku(handle, sku) {
    return variants(handle).filter(function (v) { return v.sku === sku; })[0];
  }
  function parseSize(title, unit) {
    if (!title) return null;
    var re = unit === 'L' ? /([\d.]+)\s*(?:l|litre|litres)\b/i : /([\d.]+)\s*kg/i;
    var m = title.match(re);
    return m ? parseFloat(m[1]) : null;
  }
  function priceOf(v) { return (v.price || 0) / 100; }

  // scale = how many pack-units one labelled unit really holds. Two-part kits label each
  // part separately ("4 Litres Each" = 4 L Part 1 + 4 L Part 2 = 8 L mixed) -> packScale 2.
  function packsFor(handle, unit, scale, forceUnits) {
    var ptitle = (CAT[handle] && CAT[handle].title) || '';
    var k = scale || 1;
    return variants(handle).map(function (v) {
      // forceUnits wins over the product title: Plus Base is a 20 kg bucket (TDS M520A)
      // but is still titled "...25kg" in Shopify.
      var u = forceUnits || parseSize(v.title, unit) || parseSize(ptitle, unit);
      var label = parseSize(v.title, unit) ? v.title : (parseSize(ptitle, unit) ? ptitle.replace(/^.*?(\d)/, '$1') : v.title);
      return u ? { id: v.id, units: u * k, price: priceOf(v), title: label, sku: v.sku } : null;
    }).filter(Boolean);
  }

  // min-cost combo of packs covering >= need (integer DP on ceil units)
  function bestCombo(need, packs) {
    if (!packs.length || need <= 0) return [];
    var T = Math.max(1, Math.ceil(need));
    var INF = 1e12, dp = new Array(T + 1).fill(INF), pick = new Array(T + 1).fill(null);
    dp[0] = 0;
    for (var x = 0; x <= T; x++) {
      if (dp[x] === INF) continue;
      for (var i = 0; i < packs.length; i++) {
        var p = packs[i], u = Math.max(1, Math.round(p.units));
        var nx = Math.min(T, x + u);
        if (dp[x] + p.price < dp[nx]) { dp[nx] = dp[x] + p.price; pick[nx] = { prev: x, p: p }; }
      }
    }
    var counts = {}, k = T, guard = 0;
    while (k > 0 && pick[k] && guard++ < 999) {
      var pr = pick[k]; var id = pr.p.id;
      counts[id] = counts[id] || { p: pr.p, qty: 0 };
      counts[id].qty++; k = pr.prev;
    }
    return Object.keys(counts).map(function (id) { return counts[id]; });
  }

  // Colour preview now uses each catalogue colour's own pre-computed hex (Light /
  // Mid / Deep are distinct rows), so the old depth→cream shading curve is gone —
  // the swatch is painted with state.colour.hex directly wherever a colour shows.

  // ---- core calc ----
  // One system's bill of materials for a given m². Coats come from the system
  // spec (deterministic — never a customer choice).
  function computeFor(s, area) {
    var coats = s.coats || 2;
    var lines = [];

    // primer (1 coat)
    var primerL = area / s.primer.m2PerL;
    bestCombo(primerL, packsFor(s.primer.handle, 'L', s.primer.packScale)).forEach(function (c) {
      lines.push({ role: 'Primer', handle: s.primer.handle, name: CAT[s.primer.handle].title + ' · ' + c.p.title, id: c.p.id, qty: c.qty, unit: c.p.price });
    });

    // fibreglass reinforcement mesh — every system except Internal Wall (Microestil spec)
    if (s.key !== 'wallmaster' && CFG.mesh) {
      var meshVar = variantBySku(CFG.mesh.handle, CFG.mesh.sku) || variants(CFG.mesh.handle)[0];
      if (meshVar) {
        // Mesh is sold by the square metre: the roll is 1 m wide, so 1 linear metre = 1 m2.
        // Sheets overlap >= 5 cm at every seam (Handbook p25 8.1), so order a 10% allowance.
        var meshM2 = Math.max(1, Math.ceil(area * (CFG.mesh.overlap || 1.10)));
        lines.push({ role: 'Reinforcement mesh', handle: CFG.mesh.handle, name: (CAT[CFG.mesh.handle] || {}).title || 'Fibreglass mesh', id: meshVar.id, qty: meshM2, unit: priceOf(meshVar) });
      }
    }

    // build coat (1 coat, untinted)
    var buildKg = area * s.build.kgPerM2;
    bestCombo(buildKg, packsFor(s.build.handle, 'kg')).forEach(function (c) {
      lines.push({ role: 'Base coat', handle: s.build.handle, name: CAT[s.build.handle].title + ' · ' + c.p.title, id: c.p.id, qty: c.qty, unit: c.p.price });
    });

    // finish coat (tinted, N coats)
    var finishKg = area * s.finish.kgPerM2 * coats;
    bestCombo(finishKg, packsFor(s.finish.handle, 'kg')).forEach(function (c) {
      lines.push({ role: 'Finish coat', handle: s.finish.handle, name: CAT[s.finish.handle].title + ' · ' + c.p.title, id: c.p.id, qty: c.qty, unit: c.p.price, tinted: true });
    });

    // toner (the colour) — bottles from tinted kg × dosage × scale
    var tonerVar = variantBySku('microestil-colour-toner-250ml', tonerOf(state.colour).sku);
    // Toner Ratios (Mar 25) scales off Plus Medio, which runs to 75 ml/kg on F4 at the
    // deepest shade. Capped: no applicator doses that high and the product will not take it.
    var mlkg = Math.min(state.depth.v * s.finish.scale, CFG.toner_max_mlkg || 30);
    var tonerMl = finishKg * mlkg;
    var bottles = Math.max(1, Math.ceil(tonerMl / (CFG.bottle_ml || 250)));
    if (tonerVar) {
      lines.push({
        role: 'Colour toner', handle: 'microestil-colour-toner-250ml', name: beachName(state.colour) + ' (' + state.colour.code + ') · 250ml',
        id: tonerVar.id, qty: bottles, unit: priceOf(tonerVar), colour: true,
        meta: { ml: Math.round(tonerMl), mlkg: Math.round(mlkg * 100) / 100, bottles: bottles }
      });
    }

    // sealer (units cover area × sealerCoats)
    var units = Math.max(1, Math.ceil((area * s.sealerCoats) / s.sealer.units_m2));
    s.sealer.parts.forEach(function (part) {
      var v = variantBySku(sealerHandleForSku(part.sku), part.sku);
      if (v) lines.push({ role: 'Sealer', handle: sealerHandleForSku(part.sku), name: CAT[sealerHandleForSku(part.sku)].title + ' · ' + v.title, id: v.id, qty: units * (part.qtyPer || 1), unit: priceOf(v) });
    });

    return { lines: lines, finishKg: finishKg, tonerMl: tonerMl, bottles: bottles, mlkg: mlkg };
  }

  // Whole-project bill: measured surfaces are pooled BY SYSTEM (kitchen walls +
  // living walls buy buckets together), each system's BOM is computed on its
  // pooled m², then duplicate variants across systems (shared primers, sealers,
  // toner, mesh) merge into single cart lines.
  function compute() {
    var bySys = {};
    state.areas.forEach(function (k) {
      var def = areaByKey(k); if (!def) return;
      (state.rows[k] || []).forEach(function (r) {
        var m = rowM2(r); if (!m) return;
        var sk = systemForSurface(def, r.t);
        bySys[sk] = (bySys[sk] || 0) + m;
      });
    });
    var lines = [], groups = [], totalM2 = 0, bottles = 0, tonerMl = 0, finishKg = 0, mlkg = 0;
    Object.keys(bySys).forEach(function (sk) {
      var s = sysByKey(sk); if (!s) return;
      var m2 = bySys[sk];
      totalM2 += m2;
      var r = computeFor(s, m2);
      r.lines.forEach(function (l) { lines.push(l); });
      bottles += r.bottles; tonerMl += r.tonerMl; finishKg += r.finishKg; mlkg = r.mlkg;
      groups.push({ system: s, m2: m2 });
    });
    groups.sort(function (a, b) { return b.m2 - a.m2; });

    var merged = [], seen = {};
    lines.forEach(function (l) {
      var key = l.id + '|' + l.role;
      if (seen[key]) { seen[key].qty += l.qty; } else { seen[key] = l; merged.push(l); }
    });

    if (state.kit === 'diy') {
      toolLines().forEach(function (l) { merged.push(l); });
    }

    var total = merged.reduce(function (a, l) { return a + l.qty * l.unit; }, 0);
    return { lines: merged, total: total, totalM2: totalM2, groups: groups, finishKg: finishKg, tonerMl: tonerMl, bottles: bottles, mlkg: Math.round(mlkg * 100) / 100 };
  }

  // Primary system = the one carrying the most m² (drives the stage image,
  // coverage boxes and tech table). Falls back to the product's own tag.
  function primarySystem(r) {
    if (r && r.groups && r.groups.length) return r.groups[0].system;
    return sysByKey(CFG.default_system || '') || CFG.systems[0];
  }

  // Resolve the configured Application tool set to cart line objects (qty 1 each).
  function toolSet() { return (CFG.tools && CFG.tools.set) || []; }
  function toolLines() {
    return toolSet().map(function (t) {
      var v = variantBySku(t.handle, t.sku);
      if (!v) return null;
      return {
        role: 'Application tool', handle: t.handle,
        name: (CAT[t.handle] && CAT[t.handle].title) || t.short || t.sku,
        short: t.short || ((CAT[t.handle] && CAT[t.handle].title) || t.sku),
        id: v.id, qty: 1, unit: priceOf(v), tool: true
      };
    }).filter(Boolean);
  }

  // map known sealer skus to their product handle
  function sealerHandleForSku(sku) {
    var map = {
      'M561': 'microestil-microshield', 'M560': 'microestil-microshield',
      'M577': 'superiorseal-2k-part-a', 'M574': 'superiorseal-2k-part-a',
      'M579': 'superiorseal-hardener-2k-part-b', 'M578': 'superiorseal-hardener-2k-part-b',
      'M528': 'hidrofugante-w52', 'M527': 'hidrofugante-w52'
    };
    return map[sku];
  }

  // Real Microestil spread for the FINISH product of a system, per its primary
  // bucket. Source of truth = the published spread rates (kg/m²) × the bucket
  // size actually sold. Falls back to 20kg if a coverage block isn't supplied.
  // Returns { bucketKg, perBucket (1 coat), perBucketCoats (at the system's coats) }.
  function finishCoverage(s, coats) {
    var cov = s.coverage || {};
    var bucketKg = cov.finishBucketKg || 20;
    var rate = (cov.finishKgPerM2 != null ? cov.finishKgPerM2 : s.finish.kgPerM2);
    var perBucket = rate > 0 ? Math.round(bucketKg / rate) : 0;
    var c = Math.max(1, coats || 1);
    return { bucketKg: bucketKg, rate: rate, perBucket: perBucket, perBucketCoats: Math.round(perBucket / c) };
  }
  function buildCoverage(s) {
    var cov = s.coverage || {};
    var bucketKg = cov.buildBucketKg || 25;
    var rate = (cov.buildKgPerM2 != null ? cov.buildKgPerM2 : s.build.kgPerM2);
    var perBucket = rate > 0 ? Math.round(bucketKg / rate) : 0;
    return { bucketKg: bucketKg, rate: rate, perBucket: perBucket };
  }

  // ---- render ----
  function render() {
    var r = compute();
    var prim = primarySystem(r);
    var sysLabels = r.groups.length
      ? r.groups.map(function (g) { return g.system.label; }).join(' + ')
      : prim.label;

    // stage visual: scene (primary system) tinted by the chosen colour.
    var stage = byId('mcfg-stage');
    if (stage && window.MCF_IMG && MCF_IMG.scenes[prim.key]) stage.style.backgroundImage = 'url(' + MCF_IMG.scenes[prim.key] + ')';
    var sw = byId('mcfg-swatch');
    if (sw) sw.style.background = state.colour.hex;
    var beach = beachName(state.colour);
    setText('mcfg-colour-name', beach);
    setText('mcfg-colour-code', state.colour.code + ' · ' + TONE_LABEL[state.tone]);
    setText('mcfg-system-name', sysLabels);

    // summary list (legacy layout only)
    var ul = byId('mcfg-lines');
    if (ul) {
      ul.innerHTML = '';
      r.lines.forEach(function (l) {
        var li = document.createElement('div'); li.className = 'mcfg-line' + (l.colour ? ' is-colour' : '');
        li.innerHTML = '<span class="mcfg-line__role">' + l.role + '</span>' +
          '<span class="mcfg-line__name">' + l.name + (l.qty > 1 ? ' <em>×' + l.qty + '</em>' : '') + '</span>' +
          '<span class="mcfg-line__price">' + fmt(l.qty * l.unit) + '</span>';
        ul.appendChild(li);
      });
    }

    setText('mcfg-total', fmt(r.total));
    // price display: per-m2 is the hero number; total is the secondary line
    var m2disp = Math.round(r.totalM2 * 10) / 10;
    var perM2Top = (r.totalM2 > 0) ? (r.total / r.totalM2) : 0;
    setText('mcfg-total-top', r.totalM2 > 0 ? fmt(perM2Top) + ' / m\u00b2' : '\u2014');

    // Kit-dependent copy so the result is unambiguous everywhere.
    var isDiy = state.kit === 'diy';
    setText('mcfg-price-note', isDiy ? 'Materials + tools · GST incl.' : 'Materials only · trade · GST incl.');
    setText('mcfg-incl-title', isDiy ? "What's included · Materials + tools" : "What's included · materials only");
    var inclTools = byId('mcfg-incl-tools'); if (inclTools) inclTools.style.display = isDiy ? '' : 'none';
    // mesh ships with every reinforced system (floors, wet, outdoor, pool, benchtop) — not internal walls
    var meshInBuild = !r.groups.length || r.groups.some(function (g) { return g.system.key !== 'wallmaster'; });
    var inclMesh = byId('mcfg-incl-mesh'); if (inclMesh) inclMesh.style.display = meshInBuild ? '' : 'none';
    var inclNote = byId('mcfg-incl-note');
    if (inclNote) inclNote.innerHTML = isDiy
      ? 'Installer or builder? Switch to <strong>Materials only</strong> at the top to remove the tools — same materials, your own tools.'
      : 'Materials only — the application tools are not included. Need them too? Switch to <strong>Materials + tools</strong> at the top.';
    syncKitCards();
    setText('mcfg-price-per', r.totalM2 > 0 ? '· ' + fmt(r.total) + ' total' : 'Add your measurements below to see your price.');
    setText('mcfg-toner-note', r.totalM2 > 0
      ? beach + ' needs ' + r.bottles + ' toner ' + (r.bottles > 1 ? 'bottles' : 'bottle') + ' for ' + m2disp + ' m².'
      : 'Pick your areas and measurements to see how much toner your project needs.');

    // coverage spec boxes — REAL Microestil spread for the PRIMARY system's
    // products (the system carrying the most m²). Coats come from its spec.
    var s2 = prim, primCoats = s2.coats || 2, fc = finishCoverage(s2, primCoats), bc = buildCoverage(s2);
    setText('mcfg-cov-1', fc.perBucket + ' m²');
    setText('mcfg-cov-2', fc.perBucketCoats + ' m²');
    setText('mcfg-cov-1-lbl', 'Per ' + fc.bucketKg + ' kg bucket · 1 coat');
    setText('mcfg-cov-2-lbl', 'Per bucket · at ' + primCoats + ' coat' + (primCoats > 1 ? 's' : ''));
    setText('mcfg-cov-title', 'Coverage per ' + fc.bucketKg + ' kg finish bucket');
    setText('mcfg-finish-name', (CAT[s2.finish.handle] || {}).title || '');
    setText('mcfg-base-name', (CAT[s2.build.handle] || {}).title || '');
    setText('mcfg-cov-note', 'Finish coat: ' + ((CAT[s2.finish.handle] || {}).title || '') + ' (' + fc.rate + ' kg/m²). Base build: ' + ((CAT[s2.build.handle] || {}).title || '') + ' (' + bc.rate + ' kg/m², ' + bc.perBucket + ' m² per ' + bc.bucketKg + ' kg).');
    setText('mcfg-tech-sys', sysLabels);
    setText('mcfg-crumb', s2.label + ' System');
    setText('mcfg-toner-note2', beach + ' at ' + TONE_LABEL[state.tone].toLowerCase() + ' depth needs ' + r.bottles + ' toner ' + (r.bottles > 1 ? 'bottles' : 'bottle') + ' for ' + m2disp + ' m².');

    renderSummary(r, fc);

    // hero summary cards (buy-the-system)
    var grid = byId('mcfg-syscards');
    if (grid) {
      grid.innerHTML = '';
      r.lines.forEach(function (l) {
        var card = document.createElement('div'); card.className = 'mcfg-syscard' + (l.colour ? ' is-colour' : '');
        var pimg = (window.MCF_IMG && MCF_IMG.packshots[l.role]) || '';
        var imgHtml = l.colour
          ? '<span class="mcfg-syscard__img mcfg-syscard__img--colour" style="background:' + state.colour.hex + '"></span>'
          : '<span class="mcfg-syscard__img"' + (pimg ? ' style="background-image:url(' + pimg + ')"' : '') + '></span>';
        card.innerHTML = imgHtml +
          '<span class="mcfg-syscard__role">' + l.role + '</span>' +
          '<span class="mcfg-syscard__name">' + l.name + '</span>' +
          '<span class="mcfg-syscard__qty">Qty ' + l.qty + '</span>' +
          '<span class="mcfg-syscard__price">' + fmt(l.qty * l.unit) + '</span>';
        grid.appendChild(card);
      });
    }
    window.__mcfgLast = r;
  }
  function setText(id, t) { var e = byId(id); if (e) e.textContent = t; }

  // Human unit word for a BOM role, e.g. "2 buckets", "1 bottle", "2 × 1 L".
  function unitWord(role, qty) {
    var n = qty || 0;
    var map = { 'Primer': ['tin', 'tins'], 'Reinforcement mesh': ['m²', 'm²'], 'Base coat': ['bucket', 'buckets'], 'Finish coat': ['bucket', 'buckets'], 'Pre-sealer': ['tin', 'tins'], 'Sealer': ['unit', 'units'], 'Colour toner': ['bottle', 'bottles'], 'Application tool': ['tool', 'tools'] };
    var w = map[role] || ['item', 'items'];
    return n + ' ' + (n === 1 ? w[0] : w[1]);
  }

  // ---- prominent summary (coverage headline + bill of materials) ----
  // Reads the SAME computed cart lines (r.lines) so the breakdown always
  // matches what add-to-cart adds. Renders nothing if the container is absent.
  function renderSummary(r, fc) {
    var box = byId('mcfg-summary'); if (!box) return;
    var beach = beachName(state.colour);
    var kitLabel = state.kit === 'diy' ? 'Materials + tools' : 'Materials only (trade)';
    var m2disp = Math.round(r.totalM2 * 10) / 10;
    var areaLabels = state.areas.map(function (k) { var a = areaByKey(k); return a ? a.label : k; });
    var areaTxt = !areaLabels.length ? '' : areaLabels.length <= 2 ? areaLabels.join(' + ') : areaLabels.length + ' areas';
    var sysTxt = r.groups.map(function (g) { return g.system.label; }).join(' + ') || primarySystem(r).label;
    setText('mcfg-sum-cover', r.totalM2 > 0 ? 'Covers ' + m2disp + ' m²' + (areaTxt ? ' · ' + areaTxt : '') : 'Add your measurements below');
    setText('mcfg-sum-sub', kitLabel + ' · ' + sysTxt + ' · ' + beach + ' (' + state.colour.code + ') · ' + TONE_LABEL[state.tone] + ' depth');
    var list = byId('mcfg-sum-list'); if (!list) return;
    list.innerHTML = '';
    // Materials render one row each; the DIY tools collapse into a single
    // "Application tool set" row so the BOM stays scannable.
    var tools = r.lines.filter(function (l) { return l.tool; });
    r.lines.filter(function (l) { return !l.tool; }).forEach(function (l) {
      var row = document.createElement('li');
      row.className = 'mcfg-sum__row' + (l.colour ? ' is-colour' : '');
      var dotStyle = l.colour ? ' style="background:' + state.colour.hex + '"' : '';
      var nameTxt = l.colour ? (beach + ' toner') : ((CAT[l.handle] && CAT[l.handle].title) || l.name.split(' · ')[0]);
      // Pack size as a subtle suffix — but skip it when it's a placeholder
      // ("Default Title") or already echoed by the product title (e.g. "…25kg").
      var pack = l.name.indexOf(' · ') >= 0 ? l.name.split(' · ').slice(1).join(' · ').trim() : '';
      var nameLc = nameTxt.toLowerCase(), packLc = pack.toLowerCase().replace(/\s+/g, '');
      if (!pack || /default title/i.test(pack) || nameLc.replace(/\s+/g, '').indexOf(packLc) >= 0) pack = '';
      row.innerHTML =
        '<span class="mcfg-sum__dot"' + dotStyle + '></span>' +
        '<span class="mcfg-sum__role">' + l.role + '</span>' +
        '<span class="mcfg-sum__name">' + nameTxt + (pack ? ' <em>' + pack + '</em>' : '') + '</span>' +
        '<span class="mcfg-sum__qty">' + unitWord(l.role, l.qty) + '</span>';
      list.appendChild(row);
    });
    if (tools.length) {
      var names = tools.map(function (t) { return t.short; }).join(', ');
      var qty = tools.reduce(function (a, t) { return a + t.qty; }, 0);
      var trow = document.createElement('li');
      trow.className = 'mcfg-sum__row mcfg-sum__row--tools is-tools';
      trow.innerHTML =
        '<span class="mcfg-sum__dot mcfg-sum__dot--tools"></span>' +
        '<span class="mcfg-sum__role">Tools</span>' +
        '<span class="mcfg-sum__name">Application tool set <em>' + names + '</em></span>' +
        '<span class="mcfg-sum__qty">' + unitWord('Application tool', qty) + '</span>';
      list.appendChild(trow);
    }
  }

  // ---- add to cart ----
  function addToCart() {
    var r = window.__mcfgLast || compute();
    if (!r.totalM2) {
      var calc = byId('mcfg-groups');
      if (calc) calc.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    var kitLabel = state.kit === 'diy' ? 'Materials + tools' : 'Materials only (trade)';
    var m2disp = Math.round(r.totalM2 * 10) / 10;
    var areaLabels = state.areas.map(function (k) { var a = areaByKey(k); return a ? a.label : k; }).join(' + ');
    var sysTxt = r.groups.map(function (g) { return g.system.label; }).join(' + ');
    var items = r.lines.map(function (l) {
      var props = { 'Project area': m2disp + ' m²', 'Areas': areaLabels, 'System': sysTxt, 'Kit': kitLabel };
      if (l.tinted || l.colour) {
        props['Colour'] = beachName(state.colour) + ' (' + state.colour.code + ') · ' + TONE_LABEL[state.tone];
        props['Shade'] = TONE_LABEL[state.tone];
        props['Dosage'] = r.mlkg + ' ml/kg';
      }
      if (l.colour && l.meta) props['Toner needed'] = l.meta.ml + ' ml';
      if (l.tool) props['Part of'] = 'Application tool set';
      return { id: l.id, quantity: l.qty, properties: props };
    });
    [].forEach.call(addButtons(), function (b) { b.disabled = true; b.dataset.label = b.textContent; b.textContent = 'Adding…'; });
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) throw new Error('cart');
      window.location.href = '/cart';
    }).catch(function () {
      [].forEach.call(addButtons(), function (b) { b.disabled = false; b.textContent = b.dataset.label || 'Add system to cart'; });
      alert('Sorry — could not add to cart. Please try again.');
    });
  }

  // ---- build UI: area cards (Experience-style multi-select) ----
  // Photo cards under the Residential/Commercial tabs. Tap to add an area,
  // tap again to remove. Adding an area seeds its suggested calculator rows.
  function areasForTab() {
    return AREAS.filter(function (a) {
      if (a.poolOnly && CFG.default_system !== 'poolshield') return false;
      return a.tab === state.tab;
    });
  }
  function renderAreaCards() {
    var wrap = byId('mcfg-areas'); if (!wrap) return;
    wrap.innerHTML = '';
    areasForTab().forEach(function (a) {
      var sel = state.areas.indexOf(a.key) >= 0;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mcfg-area-card' + (sel ? ' is-sel' : '');
      b.setAttribute('aria-pressed', sel ? 'true' : 'false');
      var img = AREA_IMG(a.key);
      if (img) b.style.backgroundImage = 'url(' + img + ')';
      b.innerHTML =
        '<span class="mcfg-area-card__ctx"><span>' + (a.ctx.wet ? 'Wet' : 'Dry') + '</span><span>' + (a.ctx.outdoor ? 'Outdoor' : 'Indoor') + '</span></span>' +
        '<span class="mcfg-area-card__check"><svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>' +
        '<span class="mcfg-area-card__label">' + a.label + '</span>';
      b.onclick = function () { toggleArea(a.key); };
      wrap.appendChild(b);
    });
    ['res', 'com'].forEach(function (t) {
      var n = state.areas.filter(function (k) { var a = areaByKey(k); return a && a.tab === t; }).length;
      var el = byId('mcfg-count-' + t);
      if (el) el.textContent = n ? ' · ' + n : '';
    });
  }
  function toggleArea(key) {
    if (state.areas.indexOf(key) >= 0) {
      state.areas = state.areas.filter(function (k) { return k !== key; });
      delete state.rows[key];
    } else {
      state.areas = state.areas.concat([key]);
      var def = areaByKey(key);
      state.rows[key] = def.surfaces.map(function (t) { return { t: t, mode: 'dims', a: '', b: '', m2: '' }; });
    }
    renderAreaCards(); renderCalc(); render();
  }
  function bindTabs() {
    [].forEach.call(document.querySelectorAll('.mcfg-projtab'), function (t) {
      t.addEventListener('click', function () {
        state.tab = t.dataset.projtab === 'com' ? 'com' : 'res';
        [].forEach.call(document.querySelectorAll('.mcfg-projtab'), function (x) {
          var on = x === t;
          x.classList.toggle('is-active', on);
          x.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        renderAreaCards();
      });
    });
  }

  // ---- per-area calculator (ported from the Renovation Experience step 6) ----
  function renderCalc() {
    var w = byId('mcfg-groups'); if (!w) return;
    if (!state.areas.length) {
      w.innerHTML = '<div class="mcfg-calc-empty">Select at least one project area above and your calculator appears here, pre-filled with the surfaces that space usually needs.</div>';
      return;
    }
    w.innerHTML = '';
    state.areas.forEach(function (k) {
      var a = areaByKey(k); if (!a) return;
      var rows = state.rows[k] || [];
      var g = document.createElement('div'); g.className = 'mcfg-grp';
      var gm2 = rows.reduce(function (s, r) { return s + rowM2(r); }, 0);
      g.innerHTML = '<div class="mcfg-grp__head">' +
        '<span class="mcfg-grp__name">' + a.label + '</span>' +
        '<span class="mcfg-grp__ctx ' + (a.ctx.outdoor ? 'is-out' : a.ctx.wet ? 'is-wet' : '') + '">' + (a.ctx.outdoor ? 'Outdoor · wet system' : a.ctx.wet ? 'Wet area' : 'Dry area') + '</span>' +
        '<span class="mcfg-grp__m2">' + (gm2 ? gm2.toFixed(1) + ' m²' : '0 m²') + '</span>' +
        '<button class="mcfg-grp__del" type="button" aria-label="Remove ' + a.label + ' from your project" title="Remove ' + a.label + '"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button>' +
        '</div><div class="mcfg-rows"></div>';
      g.querySelector('.mcfg-grp__del').addEventListener('click', function () { toggleArea(k); });
      var rowsEl = g.querySelector('.mcfg-rows');
      rows.forEach(function (r, i) {
        var isWall = r.t === 'wall';
        var row = document.createElement('div'); row.className = 'mcfg-row';
        var opts = Object.keys(SURFACE_LABEL).map(function (v) {
          return '<option value="' + v + '"' + (r.t === v ? ' selected' : '') + '>' + SURFACE_LABEL[v] + '</option>';
        }).join('');
        row.innerHTML =
          '<select aria-label="Surface type">' + opts + '</select>' +
          '<div class="mcfg-row__dims">' +
            '<input class="mcfg-in" type="number" min="0" step="0.1" inputmode="decimal" placeholder="Length (m)" value="' + r.a + '" data-f="a"' + (r.mode === 'm2' ? ' disabled' : '') + '>' +
            '<span class="mcfg-row__x">×</span>' +
            '<input class="mcfg-in" type="number" min="0" step="0.1" inputmode="decimal" placeholder="' + (isWall ? 'Height (m)' : 'Width (m)') + '" value="' + r.b + '" data-f="b"' + (r.mode === 'm2' ? ' disabled' : '') + '>' +
            '<span class="mcfg-row__or">or</span>' +
            '<input class="mcfg-in" type="number" min="0" step="0.1" inputmode="decimal" placeholder="Total m²" value="' + r.m2 + '" data-f="m2">' +
          '</div>' +
          '<span class="mcfg-row__m2">' + (rowM2(r) ? rowM2(r).toFixed(1) + ' m²' : ' ') + '</span>' +
          '<button class="mcfg-row__del" type="button" aria-label="Remove surface"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button>';
        row.querySelector('select').addEventListener('change', function (e) { updateRow(k, i, { t: e.target.value }); });
        [].forEach.call(row.querySelectorAll('.mcfg-in'), function (inp) {
          inp.addEventListener('input', function (e) {
            var f = e.target.dataset.f;
            var patch = {}; patch[f] = e.target.value;
            if (f === 'm2') patch.mode = e.target.value ? 'm2' : 'dims';
            updateRow(k, i, patch, true);
          });
        });
        row.querySelector('.mcfg-row__del').addEventListener('click', function () {
          state.rows[k] = rows.filter(function (_, x) { return x !== i; });
          renderCalc(); render();
        });
        rowsEl.appendChild(row);
      });
      var add = document.createElement('button');
      add.type = 'button'; add.className = 'mcfg-addrow';
      add.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg> Add surface to ' + a.label;
      add.addEventListener('click', function () {
        state.rows[k] = rows.concat([{ t: 'wall', mode: 'dims', a: '', b: '', m2: '' }]);
        renderCalc(); render();
      });
      rowsEl.appendChild(add);
      w.appendChild(g);
    });
  }
  function updateRow(k, i, patch, soft) {
    state.rows[k] = state.rows[k].map(function (r, x) {
      if (x !== i) return r;
      var next = {}; Object.keys(r).forEach(function (key2) { next[key2] = r[key2]; });
      Object.keys(patch).forEach(function (key2) { next[key2] = patch[key2]; });
      return next;
    });
    if (soft) {
      // refresh computed cells without rebuilding inputs (keeps focus)
      var groupsEls = document.querySelectorAll('#mcfg-groups .mcfg-grp');
      var g = groupsEls[state.areas.indexOf(k)];
      if (g) {
        var rows = state.rows[k];
        var gm2 = rows.reduce(function (s, r) { return s + rowM2(r); }, 0);
        g.querySelector('.mcfg-grp__m2').textContent = gm2 ? gm2.toFixed(1) + ' m²' : '0 m²';
        var cell = g.querySelectorAll('.mcfg-row__m2')[i];
        if (cell) cell.innerHTML = rowM2(rows[i]) ? rowM2(rows[i]).toFixed(1) + ' m²' : '&nbsp;';
        // typing a direct m² greys out the L×W pair (and back) without a rebuild
        if (patch.mode !== undefined) {
          var rowEl = g.querySelectorAll('.mcfg-row')[i];
          if (rowEl) [].forEach.call(rowEl.querySelectorAll('.mcfg-in'), function (inp) {
            if (inp.dataset.f !== 'm2') inp.disabled = (patch.mode === 'm2');
          });
        }
      }
      render();
    } else {
      renderCalc(); render();
    }
  }

  // ---- kit chooser (DIY vs materials-only) ----
  // Sum of the configured Application tool set, for the "+ $X tool set" hint on the card.
  function toolSetTotal() {
    return toolLines().reduce(function (a, l) { return a + l.qty * l.unit; }, 0);
  }
  function selectKit(kit) {
    if (kit !== 'diy' && kit !== 'trade') return;
    if (state.kit === kit) return;
    state.kit = kit;
    render();
  }
  function syncKitCards() {
    var wrap = byId('mcfg-kit'); if (!wrap) return;
    [].forEach.call(wrap.children, function (c) {
      var on = c.dataset && c.dataset.kit === state.kit;
      c.classList.toggle('is-active', !!on);
      c.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var meta = byId('mcfg-kit-diy-meta');
    if (meta) {
      var t = toolSetTotal();
      meta.textContent = t > 0 ? '+ ' + fmt(t) + ' tool set included' : '+ application tools included';
    }
  }
  function buildKit() {
    var wrap = byId('mcfg-kit'); if (!wrap) return;
    [].forEach.call(wrap.children, function (c) {
      if (!c.dataset || !c.dataset.kit) return;
      c.addEventListener('click', function () { selectKit(c.dataset.kit); });
    });
    syncKitCards();
  }

  // ============================================================================
  // COLOUR PICKER (catalogue grid)
  // ----------------------------------------------------------------------------
  // Cards = the catalogue colours of the active family AT the active tone. Each
  // card is a complete colour, so the tapped card === the selection === the name
  // shown on the stage. No more two-axis name disparity.
  // ============================================================================

  // Build a card element for one catalogue colour.
  function colourCard(colour) {
    var tex = (window.MCF_IMG && MCF_IMG.texture) || '';
    var card = document.createElement('button');
    card.type = 'button';
    card.className = 'mcfg-swatchcard';
    card.dataset.code = colour.code;
    card.dataset.shade = colour.shade;
    card.dataset.family = colour.family;
    card.setAttribute('role', 'option');
    card.setAttribute('aria-label', colour.name + ', ' + colour.code + ', ' + TONE_LABEL[colour.shade]);
    var swatchBg = colour.img
      ? "background-image:url('" + colour.img + "'),url('" + tex + "');background-color:" + colour.hex
      : "background-image:url('" + tex + "');background-color:" + colour.hex;
    card.innerHTML =
      '<span class="mcfg-swatchcard__sw" style="' + swatchBg + '">' +
        '<span class="mcfg-swatchcard__tint" style="background:' + colour.hex + '"></span>' +
        '<span class="mcfg-swatchcard__tick" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' +
        '</span>' +
      '</span>' +
      '<span class="mcfg-swatchcard__meta">' +
        '<span class="mcfg-swatchcard__name">' + colour.name + '</span>' +
        '<span class="mcfg-swatchcard__pill">' + TONE_LABEL[colour.shade] + '</span>' +
      '</span>' +
      '<span class="mcfg-swatchcard__code">' + colour.code + '</span>';
    card.addEventListener('click', function () { selectColourEntry(colour); });
    return card;
  }

  // Render the grid for the active family + active tone.
  function renderGrid() {
    var grid = byId('mcfg-grid'); if (!grid) return;
    var fam = state.family, tone = state.tone;
    var list = COLOURS.filter(function (c) {
      return c.shade === tone && (fam === 'all' || c.family === fam);
    });
    grid.innerHTML = '';
    list.forEach(function (c) { grid.appendChild(colourCard(c)); });
    var empty = byId('mcfg-grid-empty');
    if (empty) empty.hidden = list.length > 0;
    markActiveCard();
  }

  // Outline the card matching the current selection (code + tone).
  function markActiveCard() {
    var grid = byId('mcfg-grid'); if (!grid) return;
    [].forEach.call(grid.children, function (card) {
      var on = card.dataset && card.dataset.code === state.colour.code && card.dataset.shade === state.colour.shade;
      card.classList.toggle('is-active', !!on);
      if (on) card.setAttribute('aria-selected', 'true'); else card.removeAttribute('aria-selected');
    });
  }

  // Select a colour from a catalogue entry. Tone follows the colour's own shade
  // so the displayed name, code, tone pill, dosage and price all agree with the
  // tapped card — the fix for the Ibiza→Santorini disparity.
  function selectColourEntry(colour) {
    if (!colour) return;
    state.colour = colour;
    state.tone = colour.shade;
    state.depth = depthForTone(colour.shade);
    if (state.family !== 'all' && colour.family !== state.family) {
      state.family = colour.family;
      syncFamilyChips();
      renderGrid();
    }
    syncToneButtons();
    markActiveCard();
    render();
  }

  function syncFamilyChips() {
    var chips = byId('mcfg-families'); if (!chips) return;
    [].forEach.call(chips.children, function (c) {
      c.classList.toggle('is-active', c.dataset.family === state.family);
      c.setAttribute('aria-selected', c.dataset.family === state.family ? 'true' : 'false');
    });
  }

  function buildColours() {
    var grid = byId('mcfg-grid'); if (!grid) return;
    var chips = byId('mcfg-families');
    if (chips) [].forEach.call(chips.children, function (chip) {
      chip.setAttribute('role', 'tab');
      chip.onclick = function () {
        state.family = chip.dataset.family;
        syncFamilyChips();
        renderGrid();
        // If the current colour isn't in the new family, jump to the first card.
        if (state.family !== 'all' && state.colour.family !== state.family) {
          var first = COLOURS.filter(function (c) { return c.shade === state.tone && c.family === state.family; })[0];
          if (first) selectColourEntry(first);
        }
      };
    });
    renderGrid();
  }

  // Switch the tone axis (Light/Mid/Deep). Depth is now part of the colour
  // identity: changing tone re-filters the grid to that tone AND moves the
  // selection to the same toner's beach colour at the new tone, so the stage,
  // name, price and active card all move together.
  function selectTone(tone) {
    if (!tone || TONES.indexOf(tone) < 0) return;
    state.tone = tone;
    state.depth = depthForTone(tone);
    state.colour = siblingAtTone(state.colour, tone);
    syncToneButtons();
    renderGrid();        // re-filter to the new tone (also re-marks active card)
    render();
  }

  function syncToneButtons() {
    var wrap = byId('mcfg-depths'); if (!wrap) return;
    [].forEach.call(wrap.children, function (b) {
      var on = b.dataset.tone === state.tone;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function buildTones() {
    var wrap = byId('mcfg-depths'); if (!wrap) return;
    wrap.innerHTML = '';
    TONES.forEach(function (tone) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mcfg-depth mcfg-tone--' + tone + (tone === state.tone ? ' is-active' : '');
      b.dataset.tone = tone;
      b.setAttribute('aria-pressed', tone === state.tone ? 'true' : 'false');
      b.innerHTML = '<span class="mcfg-depth__dot"></span>' + TONE_LABEL[tone];
      b.onclick = function () { selectTone(tone); };
      wrap.appendChild(b);
    });
  }

  // Deep-link:
  //   ?colour=MCT-200            preselects that toner at its default (mid) tone
  //   ?colour=MCT-200&shade=mid  selects that exact catalogue colour
  // shade values are the catalogue keys light|mid|deep. No-op when colour is
  // absent/unknown; an unknown shade falls back to mid.
  function presetFromUrl(attempt) {
    var params;
    try { params = new URLSearchParams(window.location.search); }
    catch (e) { return; }
    var raw = params.get('colour');
    if (!raw) return;
    var code = decodeURIComponent(raw).trim().toUpperCase();

    // Guard: the grid must be built before we can select + outline a card.
    var grid = byId('mcfg-grid');
    if (!grid) {
      attempt = attempt || 0;
      if (attempt < 20) { requestAnimationFrame(function () { presetFromUrl(attempt + 1); }); }
      return;
    }

    var shadeRaw = params.get('shade');
    var shade = shadeRaw ? decodeURIComponent(shadeRaw).trim().toLowerCase() : 'mid';
    if (TONES.indexOf(shade) < 0) shade = 'mid';

    var colour = findColour(code, shade);
    if (!colour) {
      // Code present but unknown shade combo — try mid, then any tone for code.
      colour = findColour(code, 'mid') || COLOURS.filter(function (c) { return c.code === code; })[0];
    }
    if (!colour) return;
    selectColourEntry(colour);
  }

  // Map a palette's legacy 6-depth key to a catalogue tone bucket.
  var PALETTE_DEPTH_TO_TONE = { whisper: 'light', light: 'light', soft: 'mid', medium: 'mid', rich: 'deep', deep: 'deep' };

  function buildPalettes() {
    var wrap = byId('mcfg-palettes'); if (!wrap) return;
    CFG.palettes.forEach(function (p) {
      // p.colour is a toner display name; resolve to its catalogue code.
      var ton = (CFG.toners || []).filter(function (t) { return t.name === p.colour; })[0];
      var tone = PALETTE_DEPTH_TO_TONE[p.depth] || 'mid';
      var colour = ton ? findColour(ton.code, tone) : null;
      var card = document.createElement('button'); card.type = 'button'; card.className = 'mcfg-pal';
      var pimg = (window.MCF_IMG && MCF_IMG.palettes[p.name]) || '';
      var art = pimg ? 'background-image:url(' + pimg + ')' : 'background:' + (colour ? colour.hex : (ton ? ton.hex : '#ccc'));
      card.innerHTML = '<span class="mcfg-pal__art" style="' + art + '"></span>' +
        '<span class="mcfg-pal__name">' + p.name + '</span><span class="mcfg-pal__sub">' + p.sub + '</span>';
      card.onclick = function () {
        if (colour) selectColourEntry(colour);
        var top = document.getElementById('mcfg-top');
        if (top) top.scrollIntoView({ behavior: 'smooth' });
      };
      wrap.appendChild(card);
    });
  }

  function bindInputs() {
    // area + coats inputs are gone: m² comes from the calculator rows, coats
    // from each system's spec.
    [].forEach.call(document.querySelectorAll('.mcfg-add'), function (b) { b.addEventListener('click', addToCart); });
  }
  function addButtons() { return document.querySelectorAll('.mcfg-add'); }

  function buildThumbs() {
    var wrap = byId('mcfg-thumbs'); if (!wrap) return;
    // A spread of mid-tone catalogue colours as quick-pick chips on the gallery.
    var codes = ['MCT-050', 'MCT-200', 'MCT-220', 'MCT-400', 'MCT-500', 'MCT-100'];
    codes.forEach(function (code) {
      var colour = findColour(code, 'mid'); if (!colour) return;
      var b = document.createElement('button'); b.type = 'button'; b.className = 'mcfg-thumb';
      b.style.background = colour.hex; b.title = colour.name;
      b.setAttribute('aria-label', 'Select ' + colour.name);
      b.onclick = function () { selectColourEntry(colour); };
      wrap.appendChild(b);
    });
  }

  var __built = false;
  function init() {
    if (__built) return;
    if (!CFG.systems || !byId('mcfg-areas')) return; // nothing to build yet
    __built = true;
    buildKit(); bindTabs(); renderAreaCards(); renderCalc(); buildThumbs(); buildTones(); buildColours(); buildPalettes(); bindInputs(); render();
    // Apply the deep-link AFTER the configurator is fully built. presetFromUrl
    // needs the colour deck + depth buttons to exist, so it must run here.
    presetFromUrl();
  }

  // Robust boot: a plain DOMContentLoaded listener silently no-ops if this
  // script happens to execute AFTER the event already fired (Shopify cached
  // loads, instant-page / soft navigation, bfcache restores). That race left
  // the whole configurator unbuilt and the ?colour=/&shade= deep-link dead.
  // Run immediately when the DOM is already parsed; otherwise wait for it.
  function boot() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
      // Safety net in case DOMContentLoaded is missed for any reason.
      window.addEventListener('load', init, { once: true });
    } else {
      init();
    }
  }
  boot();
  // bfcache restore (back/forward): the fully-built DOM is preserved and our
  // build functions append (they don't clear), so we must NOT rebuild here or
  // we'd duplicate every card. If for some reason the deck is empty, build once.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && !__built) init();
  });
})();
